import { useTheme } from '@mui/material';
import React from 'react';

import { ContactForm } from '../ContactForm';
import { Link } from '../Link';
import { NameBanner } from '../NameBanner';
import type { ClickableSubtitleProps, ContactProps } from './Contact.types';
import {
  ContactSubtitle,
  ContactSection,
  StyledWrapper,
  ContactTitle,
  InfoStack,
  ContentStack,
  ContactSubtitleLink,
} from './styles';

export const ClickableSubtitle = ({
  children,
  color,
  link,
  target,
  rel,
}: ClickableSubtitleProps) => {
  const theme = useTheme();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const linkColor = theme.palette?.[`${color}Colors`]?.PLUS_2;

  return (
    <Link to={link} target={target} rel={rel}>
      <ContactSubtitleLink color={linkColor} variant="regular_300">
        {children}
      </ContactSubtitleLink>
    </Link>
  );
};

export const Contact = ({
  id,
  title,
  subtitle,
  color,
  subtitleComponent,
  titleComponent,
}: ContactProps) => {
  return (
    <ContactSection width="normal" borderTopOn id={id}>
      <StyledWrapper>
        <NameBanner type="section" text={'Have an idea?'} color={color} />
        <ContentStack>
          <InfoStack>
            {titleComponent ||
              (title ? (
                <ContactTitle variant="display_md">{title}</ContactTitle>
              ) : (
                <ContactTitle variant="display_md">
                  Let’s work
                  <br /> together!
                </ContactTitle>
              ))}

            {subtitleComponent ||
              (subtitle ? (
                <ContactSubtitle
                  variant="regular_500"
                  width={{ xs: '100%', md: '50%', xl: '45%' }}>
                  {subtitle}
                </ContactSubtitle>
              ) : (
                <ContactSubtitle
                  variant="regular_500"
                  width={{ xs: '100%', md: '50%', xl: '45%' }}>
                  We will answer any questions you may have related to your
                  startup journey!
                </ContactSubtitle>
              ))}

            {subtitleComponent ? null : (
              <ContactSubtitle variant="regular_300">
                Do you prefer e-mail?
                <br />
                <ClickableSubtitle
                  color={color}
                  link={'mailto:hello@rumblefish.pl'}>
                  hello@rumblefish.pl
                </ClickableSubtitle>
              </ContactSubtitle>
            )}
          </InfoStack>
          <ContactForm color={color} />
        </ContentStack>
      </StyledWrapper>
    </ContactSection>
  );
};
